import React, { useState } from 'react';
import { toast } from 'sonner';
import api from '@/lib/axios';
import { Button } from '../../components/ui/button';
import { Label } from '../../components/ui/label';
import { Textarea } from '../../components/ui/textarea';
import { Switch } from '../../components/ui/switch';
import { Loader2 } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../../components/ui/dialog';
import { formatClocks } from '@/lib/utils';

export default function AbsenceReportDialog({ lesson, onClose, onSubmitted }) {
  const [reason, setReason] = useState('');
  const [notify, setNotify] = useState(true);
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (!lesson?.student_id) {
      toast.error('Schüler:in nicht erkannt');
      return;
    }
    setBusy(true);
    try {
      await api.post('/portal/self-service/absences', {
        student_id: lesson.student_id,
        absence_date: lesson.date,
        lesson_event_id: lesson.lesson_event_id,
        reason: reason.trim() || null,
        notify_teacher: notify,
      });
      toast.success('Abwesenheit gemeldet — die Lehrperson wurde informiert.');
      onSubmitted?.();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Meldung fehlgeschlagen');
    } finally { setBusy(false); }
  };

  return (
    <Dialog open onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="max-w-md" data-testid="absence-report-dialog">
        <DialogHeader>
          <DialogTitle>Abwesenheit melden</DialogTitle>
          <DialogDescription>
            Bitte gib einen kurzen Grund an, damit die Lehrperson informiert ist.
            Die Stunde wird zur Bestätigung an den Lehrer weitergeleitet.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div className="rounded-lg bg-slate-50 p-3 text-sm">
            <p><span className="text-slate-500">Stunde:</span> <strong>{formatClocks(lesson?.course_name) || lesson?.course_name}</strong></p>
            <p><span className="text-slate-500">Datum:</span> {lesson?.date} · {lesson?.time}</p>
            <p><span className="text-slate-500">Schüler:in:</span> {lesson?.student_name}</p>
          </div>
          <div>
            <Label>Grund (optional)</Label>
            <Textarea rows={3} placeholder="z. B. krank, Familienfeier, …" value={reason} onChange={(e) => setReason(e.target.value)} data-testid="absence-reason" />
          </div>
          <div className="flex items-center justify-between">
            <Label className="text-sm">Lehrperson per Nachricht informieren</Label>
            <Switch checked={notify} onCheckedChange={setNotify} data-testid="absence-notify" />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Abbrechen</Button>
          <Button onClick={submit} disabled={busy} className="bg-rose-600 hover:bg-rose-700 text-white" data-testid="absence-submit">
            {busy ? <Loader2 className="w-4 h-4 mr-1 animate-spin" /> : null}
            Verbindlich melden
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
